/*
 * File: debug.js
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-02-05 20:06:22
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

module.exports = {
    prodMode: process.env.NODE_ENV === "production",
    title: "Val Framework",
    port: 8080,
    https: false,
    autoOpen: false,
    historyApiFallback: true,

    showNonePermissionBlock: false,
    debugFormAndTable: false,
};

// export interface Config {
//     prodMode: boolean;
//
//     title: string;
//     port: number;
//     https: boolean;
//     autoOpen: boolean;
//     historyApiFallback: boolean;
//
//     showNonePermissionBlock: boolean;
// }
